export const styleOptions = [
    'היסטוריה ותרבות', 'טבע ונוף', 'אדריכלות ואתרים דתיים', 'קולינרי / אוכל מקומי',
    'צילום ונוף', 'מים', 'אופניים', 'ג’יפים', 'פיקניק', 'טיול עונתי / פריחות', 'חופים'
].map(opt => ({ value: opt, label: opt }));

export const regionOptions = [
    'גליל עליון ותחתון',
    'רמת הגולן והכנרת',
    'אזור הכרמל וחוף הגליל',
    'השרון וגוש דן',
    'השפלה ומישור החוף הדרומי',
    'ירושלים והסביבה',
    'אזור הנגב',
    'הערבה ואילת',
    'פתוח להצעות'
].map(opt => ({ value: opt, label: opt }));

export const difficultyOptions = [
    'קלה – הליכות קצרות, מינימום מאמץ',
    'בינונית – קצת טיפוס או הליכה ממושכת',
    'מאתגרת – אתגרים פיזיים ומסלולים ארוכים'
].map(opt => ({ value: opt, label: opt }));

export const durationOptions = [
    'קצר (עד שעתיים)', 'בינוני (2–4 שעות)', 'ארוך (4–6 שעות)', 'יום שלם (6+ שעות)'
].map(opt => ({ value: opt, label: opt }));

// export const groupSizeOptions = [
//     'שניים/ שלושה אנשים', 'קבוצה קטנה (4-6)', 'קבוצה גדולה (7+)'
// ].map(opt => ({ value: opt, label: opt }));
export const groupSizeOptions = [
    { value: "pair", label: "שניים/ שלושה אנשים", maxParticipants: 3 },
    { value: "small", label: "קבוצה קטנה (4-6)", maxParticipants: 6 },
    { value: "large", label: "קבוצה גדולה (7+)", maxParticipants: 20 }
];

export const shortRegionOptions = [
    { value: 'green', label: 'ירוקים 🌿' },
    { value: 'mountains', label: 'הרריים 🏞️' },
    { value: 'urban', label: 'עירוניים 🏙️' },
    { value: 'desert', label: 'מדבריים 🏜️' }
];

